import { forwardRef, Ref } from 'react';
import c from 'classnames';

import { Kit } from '@repo/types';
import MicrobiomeScoreChart from 'components/MicrobiomeScoreChart/MicrobiomeScoreChart';
import { getPopScoreInfo } from 'views/Results/Summary/SummaryCards/MicrobiomeScoreSummaryCard/MicrobiomeScoreSummaryCard';
import LogoSvg from 'assets/images/logos/logo-full.svg';
import MyMicrobiomeResults from 'assets/images/my-microbiome-results.svg';

import styles from './MicrobiomeScoreSummaryCard.module.scss';

const MicrobiomeScoreShareImage = forwardRef(function MicrobiomeScoreShareImage(
  { kit, popScore }: { kit: Kit; popScore: number },
  ref,
) {
  const { color } = getPopScoreInfo(kit, popScore);
  return (
    <div
      className={styles.cardContainer}
      style={{ width: 400, height: 400 }}
      ref={ref as Ref<HTMLDivElement> | null}
    >
      <div className={styles.title}>
        <img src={MyMicrobiomeResults} className='mx-auto' />
      </div>
      <div className={c(styles.titleContainer, styles.isImage)}>
        <div className={c(styles.percentile, styles.margins)}>
          <span className={c(styles.percentileBig, styles[color ?? 'grey'])}>
            {Math.round(popScore)}
          </span>
          <span className='dark-grey'>/ 100</span>
        </div>
      </div>
      <div className={styles.chartContainer}>
        <MicrobiomeScoreChart
          kit={kit}
          popScore={popScore}
          // disableAnimations
          isImage
        />
      </div>
      <div className={styles.logoContainer}>
        <img src={LogoSvg} className='mx-auto' />
      </div>
    </div>
  );
});

export default MicrobiomeScoreShareImage;
